<template>
    <div>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <input
          v-model="search"
          type="text"
          class="form-control form-control-sm w-auto"
          placeholder="Cari Plat / Company"
          style="max-width:200px"
        />
      </div>
      <div class="table-responsive">
        <table class="table table-borderless table-hover mb-0">
          <tbody>
            <tr v-for="item in paginatedData" :key="item.id">
              <td class="align-middle" style="width:36px"><b>{{ item.time }}</b></td>
              <td class="align-middle" style="width:36px">
                <span
                  v-if="item.status === 'IN'"
                  class="badge badge-primary"
                  >IN</span>
                <span
                  v-else-if="item.status === 'OUT'"
                  class="badge badge-success"
                  >OUT</span>
              </td>
              <td class="align-middle" style="width:100px">{{ item.plate }}</td>
              <!-- Tampilkan semua container dalam satu kolom -->
              <td class="align-middle">
                <div class="d-flex justify-content-center" style="gap:5px;">
                  <span
                    v-for="(ctr, idx) in item.containers"
                    :key="ctr + idx"
                    class="badge badge-sm badge-warning"
                    >{{ ctr }}
                  </span>
                </div>
              </td>
              <td class="align-middle" style="width:300px;">{{ item.name }}</td>
              <td class="align-middle" style="width:90px">
                <span   
                  :class="[
                    'badge',
                    item.progress==='completed' ? 'badge-success' : '',
                    item.progress==='processing' ? 'badge-warning text-white' : '',
                    item.progress==='pending' ? 'badge-danger' : ''
                  ]"
                >{{ item.progress }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!paginatedData.length" class="text-center py-4 text-muted">No data</div>
      </div>
  
      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center mt-2">
        <small>
          Showing
          <b>{{ fromIdx + 1 }}</b>
          -
          <b>{{ Math.min(toIdx, filteredData.length) }}</b>
          of
          <b>{{ filteredData.length }}</b>
          activities
        </small>
        <PaginationEllipsis
        :page.sync="page"
        :totalPages="totalPages"
        />
        <!-- <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: page === 1 }">
            <button class="page-link" @click="prevPage" :disabled="page === 1">&laquo;</button>
          </li>
          <li
            v-for="n in totalPages"
            :key="n"
            class="page-item"
            :class="{ active: page === n }"
          >
            <button class="page-link" @click="goToPage(n)">{{ n }}</button>
          </li>
          <li class="page-item" :class="{ disabled: page === totalPages }">
            <button class="page-link" @click="nextPage" :disabled="page === totalPages">&raquo;</button>
          </li>
        </ul> -->
      </div>
    </div>
  </template>
  
  <script>
  import PaginationEllipsis from "@/components/PaginationEllipsis.vue";
  export default {
    name: 'ActivityLogTable',
    components:{PaginationEllipsis },
    props: {
      logs: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        search: '',
        page: 1,
        pageSize: 6
      }
    },
    computed: {
      filteredData() {
        // Search by plat number, driver name (lowercase)
        if (!this.search) return this.logs
        const s = this.search.toLowerCase()
        return this.logs.filter(
          log =>
            log.plate.toLowerCase().includes(s) ||
            log.name.toLowerCase().includes(s)
        )
      },
      totalPages() {
        return Math.ceil(this.filteredData.length / this.pageSize) || 1
      },
      fromIdx() {
        return (this.page - 1) * this.pageSize
      },
      toIdx() {
        return this.fromIdx + this.pageSize
      },
      paginatedData() {
        return this.filteredData.slice(this.fromIdx, this.toIdx)
      }
    }, 
    watch: {
        search() {
        this.page = 1
        }
    }
  }
  </script>
  
  <style scoped>
  .badge {
    font-size: 14px;
    padding: 6px 14px;
  }
  </style>